import { render, staticRenderFns } from "./game-view-page.vue?vue&type=template&id=bd3d3b7a&"
import script from "./game-view-page.vue?vue&type=script&lang=js&"
export * from "./game-view-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports